import CustomerService from "@/components/phones/CustomerService";
import UserEvents from "@/components/phones/UserEvents";

export default [
  {
    path: "/phones/customer-service",
    name: "CustomerService",
    component: CustomerService,
    meta: {
      requiresAuthentication: true
    }
  },
  {
    path: "/userEvents",
    name: "UserEvents",
    component: UserEvents,
    meta: {
      requiresAuthentication: true
    }
  }
];
